import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { IUserSlice, TCart, TCartItem, TUser } from "@/redux/slices/user/types";

export const deleteCartItem = createAsyncThunk(
  "user/deleteCartItem",
  async (itemId: TCartItem["id"]) =>
    await axios({
      method: "DELETE",
      url: `/api/cart/${itemId}?version=2`,
    }).then((res) => res.data)
);

const pending = (state: IUserSlice, action) => {
  // delete item
  state.cart.items = state.cart.items.map((item) => {
    if (item.id === action.meta.arg) {
      item.loading = true;
    }
    return item;
  });
};

const fulfilled = (
  state: IUserSlice,
  {
    payload,
    meta,
  }: { payload: { cart: TCart; user: TUser }; meta: { arg: number } }
) => ({
  ...state,
  user: {
    ...state.user,
    ...payload.user,
  },
  cart: {
    ...state.cart,
    ...payload.cart,
  },
});

const rejected = (state: IUserSlice, { meta }: { meta: { arg: number } }) => {
  state.cart.items = state.cart.items.map((item) => {
    if (item.id === meta.arg) {
      item.loading = false;
    }
    return item;
  });
};

export default {
  action: deleteCartItem,
  pending,
  fulfilled,
  rejected,
};
